import * as providerTypes from 'reducer/types/provider'

export const setProvider = ({provider}) => (dispatch) => {
  dispatch({
    type: providerTypes.SET_PROVIDER,
    provider
  })
}